import React from 'react';
import { Box } from '@mui/material';
import MarkdownRenderer from '../common/MarkdownRenderer';

// Versioned response section owned by BuilderProposalService.render_review.
// This changes display only; approval continues to use the saved proposal reference.
export const PLAN_DETAILS_DELIMITER = '\n\n<!-- ABV_PLAN_DETAILS_V1 -->\n\n';

type Props = { content: string; isDark?: boolean };

export default function BuilderPlanMessage({ content, isDark = false }: Props) {
  const boundary = content.indexOf(PLAN_DETAILS_DELIMITER);
  const overview = boundary > 0 ? content.slice(0, boundary) : '';
  const details = boundary > 0 ? content.slice(boundary + PLAN_DETAILS_DELIMITER.length) : '';
  if (!overview.trim() || !details.trim() || content.lastIndexOf(PLAN_DETAILS_DELIMITER) !== boundary) {
    return <MarkdownRenderer content={content} isDark={isDark} />;
  }
  return (
    <Box data-testid="builder-plan-message">
      <MarkdownRenderer content={overview} isDark={isDark} />
      <Box component="details" sx={{ mt: 2, border: '1px solid', borderColor: 'divider', borderRadius: 1 }}>
        <Box component="summary" sx={{ p: 1.5, cursor: 'pointer', fontWeight: 600,
          '&:focus-visible': { outline: '2px solid', outlineColor: 'primary.main', outlineOffset: 2 } }}>
          View full plan details
        </Box>
        <Box sx={{ px: 2, pb: 2 }}>
          <MarkdownRenderer content={details} isDark={isDark} />
        </Box>
      </Box>
    </Box>
  );
}
